import { Trash2 } from "lucide-react";
import { useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";

interface Props {
  isOpen: boolean;
  name: string;
  toggle: () => void;
  onDelete: () => void;
  loading?: boolean;
}

const DeleteuserModal = ({
  isOpen,
  name,
  toggle,
  onDelete,
  loading = false
}: Props) => {

    const [deleting, setDeleting] = useState(false);




  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      style={{borderTopLeftRadius:"20px"}}
    >
      <div>
        <ModalHeader
          toggle={toggle}
          style={{
            background: "linear-gradient(135deg,#2563eb,#4f46e5)",
            color: "#fff",
            borderBottom: "none",
            fontWeight: 700,
          }}
        >
          Delete User
        </ModalHeader>

        <ModalBody
          style={{
            textAlign: "center",
            padding: "35px 25px",
          }}
        >
          <div
            style={{
              width: "90px",
              height: "90px",
              margin: "0 auto 20px",
              borderRadius: "50%",
              background: "#84a8f5",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Trash2
              size={45}
              color="#326ef0"
              strokeWidth={2.5}
            />
          </div>

          <h4
            style={{
              fontWeight: 700,
              color: "#1e293b",
              marginBottom: "10px",
            }}
          >
            Delete User?
          </h4>

          <p
            style={{
              color: "#64748b",
              fontSize: "15px",
              marginBottom: "10px",
            }}
          >
            Are you sure you want to delete
          </p>

          <div
            style={{
              fontWeight: 700,
              color: "#dc2626",
              fontSize: "18px",
            }}
          >
            {name}
          </div>

         
        </ModalBody>

        <ModalFooter
          style={{
            borderTop: "none",
            justifyContent: "center",
            gap: "12px",
            paddingBottom: "25px",
          }}
        >
          <Button
            color="light"
            onClick={toggle}
            disabled={loading}
            style={{
              borderRadius: "10px",
              minWidth: "120px",
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>

          <Button
            color="danger"
            onClick={onDelete}
            disabled={loading}
            style={{
              borderRadius: "10px",
              minWidth: "120px",
              fontWeight: 600,
            }}
          >
            {loading ? "Deleting..." : "Delete"}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

export default DeleteuserModal;